import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedinIn,
  faFacebookF,
  faInstagram,
  faYoutube,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import {
  faPhone,
  faEnvelope,
  faLocationDot,
  faChevronRight,
  faChevronDown,
  faLink,
  faGraduationCap,
  faFileLines,
  faShieldHalved,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";
import assetUrl from "../../services/assetUrl";
import siteDefault from "../../data/site/site.json";
import { getSiteSettings } from "../../services/data.service";
import "./footerModern.css";

const SOCIAL_ICON_MAP = {
  linkedin: { icon: faLinkedinIn, cls: "ncet-footer-lw__social-btn--linkedin", defaultLabel: "LinkedIn" },
  facebook: { icon: faFacebookF, cls: "ncet-footer-lw__social-btn--facebook", defaultLabel: "Facebook" },
  instagram: { icon: faInstagram, cls: "ncet-footer-lw__social-btn--instagram", defaultLabel: "Instagram" },
  youtube: { icon: faYoutube, cls: "ncet-footer-lw__social-btn--youtube", defaultLabel: "YouTube" },
  x: { icon: faXTwitter, cls: "ncet-footer-lw__social-btn--x", defaultLabel: "X (Twitter)" },
  twitter: { icon: faXTwitter, cls: "ncet-footer-lw__social-btn--x", defaultLabel: "X (Twitter)" },
};

const COLUMN_ICON_MAP = {
  links: faLink,
  cap: faGraduationCap,
  report: faFileLines,
  shield: faShieldHalved,
  academics: faGraduationCap,
  reports: faFileLines,
  policies: faShieldHalved,
};

const FOOTER_DATA = {
  importantLinks: [
    { label: "Careers", to: "/careers" },
    { label: "Gallery", to: "/gallery" },
    { label: "NIRF", to: "/nirf" },
    { label: "IIC", to: "/iic" },
    { label: "Blogs", to: "/blog" },
    { label: "Approvals & Disclosures", to: "/approvals-and-disclosure" },
    { label: "Best Practices", to: "/footer/Best-practices-of-the-Institution.pdf", external: true },
    { label: "Service Manual", to: "/footer/NCET-Service-Manual.pdf", external: true },
    { label: "Syllabus - I Semester", to: "/footer/1st_Sem_Syllabus.pdf", external: true },
    { label: "Brochure - UG", to: "/footer/NCET_UG_Brochure_2026.pdf", external: true },
  ],
  academics: [
    { label: "Brochure - PG", to: "/footer/NCET_PG_Brochure_2026.pdf", external: true },
    { label: "Hostels", to: "/hostels" },
    { label: "Alumni", to: "/alumni" },
    { label: "Transportation", to: "/footer/NCET_Bus_Route_Details.pdf", external: true },
    { label: "Library", to: "http://192.168.1.100/opac/", external: true },
    { label: "Online Student Feedback", to: "https://www.aicte-india.org/feedback/index.php", external: true },
    { label: "NISP Policy", to: "/nisp-policy" },
  ],
  reportsAndPublications: [
    { label: "Samashti", to: "/samashti" },
    { label: "Monthly Reports", to: "/monthly-reports" },
  ],
  accreditationReports: [
    { label: "Audit Reports", to: "/audit-reports" },
    { label: "NBA Visit Data", to: "/nba-visit-data" },
  ],
  policiesAndGuidelines: [
    { label: "Privacy Policy", to: "/privacy-policy" },
    { label: "Terms & Conditions", to: "/terms-conditions" },
    { label: "NISP Policy", to: "/nisp-policy" },
    { label: "Autonomous Regulations", to: "/autonomous-regulations" },
    { label: "Anti-Ragging Policies", to: "/footer/Anti-Ragging-Committee.pdf", external: true },
    { label: "Internal Complaint Committee", to: "/footer/CICC2023-24.pdf", external: true },
    { label: "Equal Opportunities Cell", to: "/footer/Equal-Opportunities-Cell.pdf", external: true },
    { label: "Student Grievance Redressal Cell", to: "/footer/SGRC-2023-24.pdf", external: true },
  ],
};

const ToriiWhiteLogo = () => (
  <svg
    className="ncet-footer-lw__torii-svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 240"
    height="22"
    aria-label="TORII Minds"
  >
    <path d="M60,80.31v-7.85h68.97v7.85h-30.12v87.23h-8.61v-87.23h-30.24Z" fill="#ffffff" />
    <path
      d="M176.11,168.81c-8,0-15.1-2-21.31-6-6.21-4-11.07-9.66-14.58-16.97-3.51-7.32-5.26-15.91-5.26-25.78s1.76-18.54,5.3-25.88c3.53-7.34,8.39-13.01,14.58-17.01,6.19-4,13.28-6,21.28-6s15.08,2,21.25,6c6.17,4,11.01,9.67,14.52,17.01,3.51,7.34,5.26,15.96,5.26,25.88s-1.75,18.46-5.26,25.78c-3.51,7.32-8.35,12.97-14.52,16.97-6.17,4-13.25,6-21.25,6ZM176.11,160.71c6.21,0,11.78-1.62,16.72-4.85,4.93-3.23,8.83-7.88,11.68-13.94,2.85-6.06,4.28-13.35,4.28-21.85s-1.43-15.87-4.28-21.95c-2.85-6.08-6.74-10.74-11.68-13.97-4.93-3.23-10.51-4.85-16.72-4.85s-11.79,1.62-16.75,4.85c-4.96,3.23-8.87,7.89-11.74,13.97-2.87,6.08-4.31,13.4-4.31,21.95s1.43,15.74,4.28,21.82c2.85,6.08,6.75,10.74,11.71,13.97,4.95,3.23,10.56,4.85,16.81,4.85Z"
      fill="#ffffff"
    />
    <path
      d="M232.76,167.54v-95.08h30.75c6.76,0,12.4,1.22,16.91,3.67,4.51,2.45,7.92,5.82,10.24,10.11,2.32,4.3,3.48,9.21,3.48,14.74s-1.15,10.41-3.45,14.64c-2.3,4.23-5.71,7.54-10.24,9.92-4.53,2.38-10.13,3.57-16.81,3.57h-26.1v-7.91h25.84c4.98,0,9.1-.83,12.38-2.49,3.27-1.66,5.73-4,7.37-7.02,1.64-3.02,2.46-6.59,2.46-10.72s-.83-7.81-2.49-10.91c-1.66-3.1-4.13-5.51-7.4-7.21-3.28-1.7-7.42-2.55-12.44-2.55h-21.82v87.23h-8.68ZM288.02,167.54l-23.1-42.94h9.83l23.35,42.94h-10.08Z"
      fill="#ffffff"
    />
    <path d="M318.63,72.46v95.08h-8.68v-95.08h8.68Z" fill="#ffffff" />
    <polygon points="440 72.45 440 167.46 432 167.46 432 80.45 346.48 80.45 346.48 167.46 338.48 167.46 338.48 72.45 440 72.45" fill="#ffffff" />
    <rect x="385.52" y="102.65" width="8" height="64.81" fill="#ffffff" />
    <polygon points="395.69 92.57 390.44 92.57 394.18 96.31 393.47 97.01 389.73 93.27 389.73 98.53 388.72 98.53 388.72 93.26 385.03 96.97 384.32 96.27 388.01 92.57 382.79 92.57 382.79 91.57 388.02 91.57 384.35 87.9 385.06 87.2 388.72 90.87 388.72 85.65 389.73 85.65 389.73 90.86 393.43 87.15 394.15 87.85 390.43 91.57 395.69 91.57 395.69 92.57" fill="#ffffff" />
  </svg>
);

const FooterLinkItem = ({ item }) => {
  const isExt = item.external || item.to.startsWith("http") || item.to.endsWith(".pdf");
  const href = assetUrl(item.to);

  if (isExt) {
    return (
      <li>
        <a href={href} target="_blank" rel="noopener noreferrer" className="ncet-footer-lw__link">
          <span>{item.label}</span>
          <FontAwesomeIcon icon={faChevronRight} className="ncet-footer-lw__chevron" />
        </a>
      </li>
    );
  }

  return (
    <li>
      <Link to={item.to} className="ncet-footer-lw__link">
        <span>{item.label}</span>
        <FontAwesomeIcon icon={faChevronRight} className="ncet-footer-lw__chevron" />
      </Link>
    </li>
  );
};

const Footer = ({ footerClass }) => {
  const year = new Date().getFullYear();
  const [footerSettings, setFooterSettings] = useState(siteDefault.footer || {});
  const [openMobileCols, setOpenMobileCols] = useState({});

  const toggleMobileCol = (id) => {
    setOpenMobileCols((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await getSiteSettings();
        const d = res?.data?.data;
        if (active && d && d.footer) {
          setFooterSettings(d.footer);
        }
      } catch (e) {
        // keep default fallback
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  const logoSrc = footerSettings.logoLight || siteDefault.footer?.logoLight || "/images/footer_logo.png";
  const poweredLogo = footerSettings.poweredByLogo || siteDefault.footer?.poweredByLogo;
  const poweredUrl = footerSettings.poweredByUrl || siteDefault.footer?.poweredByUrl || "https://toriiminds.com/";

  // Social links list
  const socialList = (footerSettings.social && footerSettings.social.length > 0)
    ? footerSettings.social
    : (siteDefault.footer?.social || []);

  // Contact details
  const tollFree = footerSettings.tollFree?.numbers?.length > 0
    ? footerSettings.tollFree
    : siteDefault.footer?.tollFree;

  const email = footerSettings.email?.value
    ? footerSettings.email
    : siteDefault.footer?.email || { value: "info@ncetmail.com" };

  const address = footerSettings.address?.text
    ? footerSettings.address
    : siteDefault.footer?.address || {
        text: "Nagarjuna College of Engineering & Technology, Beedaganahalli, Venkatagiri Kote Post, Devanahalli, Bengaluru, Karnataka 562135",
        mapUrl: "https://maps.app.goo.gl/RoyhYoL2aFTeu2jL9",
      };

  // Grouped toll numbers (first 2 as Toll Free highlight, rest as alternate numbers)
  const tollNumbers = tollFree?.numbers || [
    { text: "080 3552 5181", tel: "08035525181" },
    { text: "080 3552 5182", tel: "08035525182" },
    { text: "080674 62700", tel: "08067462700" },
    { text: "8722992333", tel: "8722992333" },
  ];
  const tollHighlights = tollNumbers.slice(0, 2);
  const tollOthers = tollNumbers.slice(2);

  // Normalized columns array for easy rendering across both desktop and mobile
  const activeCols = [
    {
      id: "links",
      title: "IMPORTANT LINKS",
      icon: "links",
      links: FOOTER_DATA.importantLinks,
    },
    {
      id: "academics",
      title: "ACADEMICS",
      icon: "cap",
      links: FOOTER_DATA.academics,
    },
    {
      id: "reports",
      title: "REPORTS & PUBLICATIONS",
      icon: "report",
      links: [...FOOTER_DATA.reportsAndPublications, ...FOOTER_DATA.accreditationReports],
    },
    {
      id: "policies",
      title: "POLICIES & GUIDELINES",
      icon: "shield",
      links: FOOTER_DATA.policiesAndGuidelines,
    },
  ];

  return (
    <footer className={`ncet-footer-lw ${footerClass || ""}`} id="react-footer">
      {/* Main Footer Container */}
      <div className="ncet-footer-lw__container">
        {/* Desktop View: Full 4-Column Layout */}
        <div className="ncet-footer-lw__desktop-view">
          <div className="ncet-footer-lw__grid">
            {/* Column 1: Brand & Contact Info */}
            <div className="ncet-footer-lw__brand-col">
              <div className="ncet-footer-lw__logo-wrap">
                <Link to="/">
                  <img
                    src={assetUrl(logoSrc)}
                    alt="Nagarjuna Group of Institutions"
                    className="ncet-footer-lw__logo"
                  />
                </Link>
              </div>

              <h4 className="ncet-footer-lw__contact-title">CONTACT US AT</h4>

              <ul className="ncet-footer-lw__contact-list">
                {tollHighlights.length > 0 && (
                  <li className="ncet-footer-lw__contact-item">
                    <FontAwesomeIcon icon={faPhone} className="ncet-footer-lw__contact-icon" />
                    <div className="ncet-footer-lw__contact-text ncet-footer-lw__toll-highlight">
                      {tollFree?.label || "Toll Free"}:{" "}
                      {tollHighlights.map((n, idx) => (
                        <React.Fragment key={idx}>
                          <a href={`tel:${n.tel || n.text}`}>{n.text}</a>
                          {idx < tollHighlights.length - 1 ? ", " : ""}
                        </React.Fragment>
                      ))}
                    </div>
                  </li>
                )}

                {tollOthers.length > 0 && (
                  <li className="ncet-footer-lw__contact-item">
                    <FontAwesomeIcon icon={faPhone} className="ncet-footer-lw__contact-icon" />
                    <div className="ncet-footer-lw__contact-text">
                      {tollOthers.map((n, idx) => (
                        <React.Fragment key={idx}>
                          <a href={`tel:${n.tel || n.text}`}>{n.text}</a>
                          {idx < tollOthers.length - 1 ? " | " : ""}
                        </React.Fragment>
                      ))}
                    </div>
                  </li>
                )}

                {email?.value && (
                  <li className="ncet-footer-lw__contact-item">
                    <FontAwesomeIcon icon={faEnvelope} className="ncet-footer-lw__contact-icon" />
                    <div className="ncet-footer-lw__contact-text">
                      <a href={`mailto:${email.value}`}>{email.value}</a>
                    </div>
                  </li>
                )}

                {address?.text && (
                  <li className="ncet-footer-lw__contact-item">
                    <FontAwesomeIcon icon={faLocationDot} className="ncet-footer-lw__contact-icon" />
                    <div className="ncet-footer-lw__contact-text">
                      {address.mapUrl ? (
                        <a
                          href={address.mapUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {address.text}
                        </a>
                      ) : (
                        <span>{address.text}</span>
                      )}
                    </div>
                  </li>
                )}
              </ul>
            </div>

            {/* Column 2: Important Links */}
            <div className="ncet-footer-lw__nav-col">
              <h4 className="ncet-footer-lw__heading">IMPORTANT LINKS</h4>
              <ul className="ncet-footer-lw__links">
                {FOOTER_DATA.importantLinks.map((item, idx) => (
                  <FooterLinkItem key={idx} item={item} />
                ))}
              </ul>
            </div>

            {/* Column 3: Academics + Reports & Publications */}
            <div className="ncet-footer-lw__nav-col">
              <div className="ncet-footer-lw__col-group">
                <h4 className="ncet-footer-lw__heading">ACADEMICS</h4>
                <ul className="ncet-footer-lw__links">
                  {FOOTER_DATA.academics.map((item, idx) => (
                    <FooterLinkItem key={idx} item={item} />
                  ))}
                </ul>
              </div>

              <div className="ncet-footer-lw__col-group ncet-footer-lw__col-group--reports">
                <h4 className="ncet-footer-lw__heading">REPORTS & PUBLICATIONS</h4>
                <ul className="ncet-footer-lw__links">
                  {FOOTER_DATA.reportsAndPublications.map((item, idx) => (
                    <FooterLinkItem key={idx} item={item} />
                  ))}
                </ul>
              </div>
            </div>

            {/* Column 4: Top links (Audit Reports, NBA Visit Data) + POLICIES & GUIDELINES */}
            <div className="ncet-footer-lw__nav-col">
              <div className="ncet-footer-lw__col-group ncet-footer-lw__col-group--top-reports">
                <ul className="ncet-footer-lw__links">
                  {FOOTER_DATA.accreditationReports.map((item, idx) => (
                    <FooterLinkItem key={idx} item={item} />
                  ))}
                </ul>
              </div>

              <div className="ncet-footer-lw__col-group">
                <h4 className="ncet-footer-lw__heading">POLICIES & GUIDELINES</h4>
                <ul className="ncet-footer-lw__links">
                  {FOOTER_DATA.policiesAndGuidelines.map((item, idx) => (
                    <FooterLinkItem key={idx} item={item} />
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile View: Brand info on top + Card Accordions below */}
        <div className="ncet-footer-lw__mobile-view">
          <div className="ncet-footer-lw__brand-col">
            <div className="ncet-footer-lw__logo-wrap">
              <Link to="/">
                <img
                  src={assetUrl(logoSrc)}
                  alt="Nagarjuna Group of Institutions"
                  className="ncet-footer-lw__logo"
                />
              </Link>
            </div>

            <h4 className="ncet-footer-lw__contact-title">CONTACT US AT</h4>

            <ul className="ncet-footer-lw__contact-list">
              {tollHighlights.length > 0 && (
                <li className="ncet-footer-lw__contact-item">
                  <FontAwesomeIcon icon={faPhone} className="ncet-footer-lw__contact-icon" />
                  <div className="ncet-footer-lw__contact-text ncet-footer-lw__toll-highlight">
                    {tollFree?.label || "Toll Free"}:{" "}
                    {tollHighlights.map((n, idx) => (
                      <React.Fragment key={idx}>
                        <a href={`tel:${n.tel || n.text}`}>{n.text}</a>
                        {idx < tollHighlights.length - 1 ? ", " : ""}
                      </React.Fragment>
                    ))}
                  </div>
                </li>
              )}

              {tollOthers.length > 0 && (
                <li className="ncet-footer-lw__contact-item">
                  <FontAwesomeIcon icon={faPhone} className="ncet-footer-lw__contact-icon" />
                  <div className="ncet-footer-lw__contact-text">
                    {tollOthers.map((n, idx) => (
                      <React.Fragment key={idx}>
                        <a href={`tel:${n.tel || n.text}`}>{n.text}</a>
                        {idx < tollOthers.length - 1 ? " | " : ""}
                      </React.Fragment>
                    ))}
                  </div>
                </li>
              )}

              {email?.value && (
                <li className="ncet-footer-lw__contact-item">
                  <FontAwesomeIcon icon={faEnvelope} className="ncet-footer-lw__contact-icon" />
                  <div className="ncet-footer-lw__contact-text">
                    <a href={`mailto:${email.value}`}>{email.value}</a>
                  </div>
                </li>
              )}

              {address?.text && (
                <li className="ncet-footer-lw__contact-item">
                  <FontAwesomeIcon icon={faLocationDot} className="ncet-footer-lw__contact-icon" />
                  <div className="ncet-footer-lw__contact-text">
                    {address.mapUrl ? (
                      <a
                        href={address.mapUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {address.text}
                      </a>
                    ) : (
                      <span>{address.text}</span>
                    )}
                  </div>
                </li>
              )}
            </ul>
          </div>

          <div className="ncet-footer-lw__mobile-accordion">
            {activeCols.map((col, idx) => {
              const colId = col.id || `col-${idx}`;
              const isOpen = !!openMobileCols[colId];
              const iconType = COLUMN_ICON_MAP[col.icon] || COLUMN_ICON_MAP[col.id] || faLink;

              return (
                <div
                  className={`ncet-footer-mobile-card ${isOpen ? "is-open" : ""}`}
                  key={colId}
                >
                  <button
                    type="button"
                    className="ncet-footer-mobile-card__header"
                    onClick={() => toggleMobileCol(colId)}
                    aria-expanded={isOpen}
                  >
                    <div className="ncet-footer-mobile-card__icon-wrap">
                      <FontAwesomeIcon icon={iconType} />
                    </div>
                    <div className="ncet-footer-mobile-card__title-wrap">
                      <span className="ncet-footer-mobile-card__title">{col.title}</span>
                      <span className="ncet-footer-mobile-card__bar" />
                    </div>
                    <FontAwesomeIcon
                      icon={faChevronDown}
                      className={`ncet-footer-mobile-card__chevron ${isOpen ? "is-rotated" : ""}`}
                    />
                  </button>

                  {isOpen && (
                    <div className="ncet-footer-mobile-card__body">
                      <ul className="ncet-footer-lw__links">
                        {(col.links || []).map((item, lIdx) => (
                          <FooterLinkItem key={lIdx} item={item} />
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Solid Orange Bottom Bar */}
      <div className="ncet-footer-lw__bottom">
        <div className="ncet-footer-lw__bottom-inner">
          <p className="ncet-footer-lw__copyright">
            &copy; {year} Nagarjuna Group Of Education. All Rights Reserved.
          </p>

          <div className="ncet-footer-lw__bottom-right">
            {socialList.length > 0 && (
              <div className="ncet-footer-lw__follow">
                <span className="ncet-footer-lw__follow-label">FOLLOW US ON</span>
                <ul className="ncet-footer-lw__socials">
                  {socialList.map((s, idx) => {
                    const iconKey = (s.icon || "").toLowerCase().trim();
                    const iconMeta = SOCIAL_ICON_MAP[iconKey] || {
                      icon: faGlobe,
                      cls: "ncet-footer-lw__social-btn--generic",
                      defaultLabel: "Social Link",
                    };
                    return (
                      <li key={idx}>
                        <a
                          href={assetUrl(s.href)}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label={s.label || iconMeta.defaultLabel}
                          className={`ncet-footer-lw__social-btn ${iconMeta.cls}`}
                        >
                          <FontAwesomeIcon icon={iconMeta.icon} />
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}

            <div className="ncet-footer-lw__divider" aria-hidden="true" />

            <div className="ncet-footer-lw__powered">
              <span>Powered by</span>
              <a
                href={poweredUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Powered By Torii Minds"
                className="ncet-footer-lw__powered-logo"
              >
                {poweredLogo && poweredLogo.trim() !== "" ? (
                  <img
                    src={assetUrl(poweredLogo)}
                    alt="Powered By"
                    style={{ height: "24px", width: "auto", objectFit: "contain" }}
                  />
                ) : (
                  <ToriiWhiteLogo />
                )}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
